import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiFloppyDisk, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { ICreateEmail } from 'services/email/types';
import { useGetEmail, usePutEmail } from 'services/email/email';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getLastPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowToast } from 'utils/service/errorHandler';
import { emailFormInitialValues } from 'components/organisms/forms/email/EmailForm';

const EditEmail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const salesChannelId = useParamId('settings/email');
  const { pathname } = useLocation();

  const updateEmail = usePutEmail();

  const { data: email, isLoading } = useGetEmail(salesChannelId);
  const mutateOptions = useMutateOptions<ICreateEmail>();



  const onGoToDetail = () =>
    navigate(`/settings/email/${salesChannelId}`);


  const submitForm = async (
    values: ICreateEmail,
    helpers: FormikHelpers<ICreateEmail>
  ) => {


    await updateEmail.mutateAsync(
      {
        id: salesChannelId,
        ...values
      },
      {
        onSuccess: onGoToDetail,
        ...mutateOptions(helpers),
      }
    );
  };

  return (
    <Form.Email
      initialValues={
        email
          ? email
          : emailFormInitialValues
      }
      onSubmit={submitForm}
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate(
              `/settings/email/${getLastPathname(pathname)}`
            );
          }}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
          <Button.Icon icon={<PiFloppyDisk />} />
        </Button>
      }
      tittle={email?.name || '-'}
      backPath={pathname}
      status={{ isLoading }}
    />
  );
};

export default EditEmail;
